import React, { FC } from 'react';
import { MessageSimple, useMessageContext } from 'stream-chat-react';
import { Grid, lighten, makeStyles, Typography } from '@material-ui/core';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import { MessageUIComponentProps } from 'stream-chat-react/dist/components/Message/types';
import { CustomSVG } from 'components';

const useStyles = makeStyles(theme => ({
  pinned: {
    background: lighten(theme.palette.primary.light, 0.1),
    padding: theme.spacing(0, 5),
    margin: theme.spacing(0, -5),
  },
  icon: {
    marginRight: theme.spacing(0.5),
  },
  pin: {
    color: lighten(theme.palette.common.black, 0.5),
    fontSize: 11,
  },
}));

const MessageCustom: FC<MessageUIComponentProps> = props => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { message } = useMessageContext();

  const { pinned } = message;

  return (
    <Grid className={classNames({ [classes.pinned]: pinned })}>
      {pinned && (
        <Grid container alignItems="center" direction="row" justify="flex-start">
          <CustomSVG name="pin" color="primary" size={16} className={classes.icon} />
          <Typography noWrap className={classes.pin}>
            {t('content:pinned')}
          </Typography>
        </Grid>
      )}
      <MessageSimple {...props} />
    </Grid>
  );
};

export default MessageCustom;
